import { render } from "./MurojaahPage.vue?vue&type=template&id=0775a836&scoped=true"
import script from "./MurojaahPage.vue?vue&type=script&lang=js"
export * from "./MurojaahPage.vue?vue&type=script&lang=js"

import "./MurojaahPage.vue?vue&type=style&index=0&id=0775a836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0775a836"]])

export default __exports__